(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'lodash/union', '../util/convert'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('lodash/union'), require('../util/convert'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.union, global.convert);
    global.union = mod.exports;
  }
})(this, function (exports, _union2, _convert) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = exports.union = undefined;

  var _union3 = _interopRequireDefault(_union2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /**
   * Replaces an array by an array of unique values, in order, from the former array and the given arrays.
   * @function
   * @memberof array
   * @param {Object} object The object to modify.
   * @param {Array|string} path The path of the property to set.
   * @param {...Array} [arrays] The arrays to inspect.
   * @return {Object} Returns the updated object.
   * @example union({ nested: { prop: [1, 2] } }, 'nested.prop', [2, 3]) // => { nested: { prop: [1, 2, 3] } }
   * @see {@link https://lodash.com/docs#union|lodash.union} for more information.
   * @since 0.3.0
   */
  var union = (0, _convert.convert)(_union3.default);
  exports.union = union;
  exports.default = union;
});